exports.clientEnvVars = function getClientEnvVars() {
  const element = document && document.getElementById('clientEnvVars');
  return element ? JSON.parse(element.innerHTML) : {};
};
